import React, { useEffect, useState, useCallback } from "react";
import styles from "./HeatMap.module.css";
import vector from "../../../assets/images/Vector.svg";
import MultiSelectWithSearchInput from "../../components/dropdown/MultiSelectWithInput";
import { ListItem } from "@mui/material";
import { styled } from "@mui/system";
import resetBtn from "../../../assets/images/resetBtn.png";
import CustomTooltip from "utils/CustomTooltip";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@mui/material";
import { useInfiniteScrollHomePage } from "Samarth Module/pages/dailyPhasing/hooks/useInfiniteScrollHomePage";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
	"&.MuiTableCell-head": {
		fontFamily: "Unilever Shilling",
		color: "#fff",
		textAlign: "center",
		padding: "5px",
		fontSize: "12px",
		fontWeight: 600,
		border: "1px solid #EAECF0",
		whiteSpace: "nowrap",
	},
	"&.MuiTableCell-body": {
		fontFamily: "Unilever Shilling",
		fontSize: "12px",
		fontWeight: 400,
		padding: "5px",
		color: "#2B2B2B",
		border: "1px solid #EAECF0",
		textAlign: "center",
		whiteSpace: "nowrap",
		"&:nth-of-type(3)": {
			textAlign: "left",
			maxWidth: "11rem",
			overflow: "hidden",
			textOverflow: "ellipsis",
			color: "#354ACD",
			fontWeight: 600,
		},
	},
}));

const StyledTableRow = styled(TableRow)({
	backgroundColor: "#FFFFFF !important"
});

const HeatMap = ({ data, label, filterObj, columnList }) => {
	const labelView = label;
	const [filterObject, setFilterObject] = useState(filterObj);
	const [tableData, setTableData] = useState(data);
	const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
	const { chankData, containerRef } = useInfiniteScrollHomePage(tableData, 10);
	const getBGColor = (value, col) => {
		if (col === 'DOH') {
			if(value || value >= 0){
				return {
					backgroundColor: "#E5EFFD",
					border: "1px solid #E5EFFD",
					borderRadius: '4px'
				};
			}
			
		} else if(col === 'Bottle neck RM'){
			if(value === 'Yes'){
				return {
					backgroundColor: "#FF9998",
					border: "1px solid #FF9998",
					borderRadius: '4px'
				};
			}
			if(value === 'No'){
				return {
					backgroundColor: "#A3E1D2",
					border: "1px solid #A3E1D2",
					borderRadius: '4px'
				};
			}
			
		} else if(col === 'MAI'){
			let val = typeof value === 'string' ?  parseFloat(value?.replace('%', '')) : value;
			if (val >= 80 ) {
				return {
					backgroundColor: "#A3E1D2",
					border: "1px solid #A3E1D2",
					borderRadius: '4px'
				};
			}
			if (val < 80 && val >= 60) {
				return {
					backgroundColor: "#FFEC9A",
					border: "1px solid #FFEC9A",
					borderRadius: '4px'
				};
			}
			if (val < 60 ) {
				return {
					backgroundColor: "#FF9998",
					border: "1px solid #FF9998",
					borderRadius: '4px'
				};
			}
		}else if(col === 'Norm coverage'){
			let val = typeof value === 'string' ?  parseFloat(value?.replace('%', '')) : value;
			if (val > 100 ) {
				return {
					backgroundColor: "#80cbc4",
					border: "1px solid #80cbc4",
					borderRadius: '4px'
				};
			}
			if (val <= 100 && val >= 75) {
				return {
					backgroundColor: "#A3E1D2",
					border: "1px solid #A3E1D2",
					borderRadius: '4px'
				};
			}
			if (val < 75 && val >= 50) {
				return {
					backgroundColor: "#FFEC9A",
					border: "1px solid #FFEC9A",
					borderRadius: '4px'
				};
			}
			if (val < 50 ) {
				return {
					backgroundColor: "#FF9998",
					border: "1px solid #FF9998",
					borderRadius: '4px'
				};
			}
		}else {
			let val = typeof value === 'string' ?  parseFloat(value?.replace('%', '')) : value;
			if (val >= 70 ) {
				return {
					backgroundColor: "#A3E1D2",
					border: "1px solid #A3E1D2",
					borderRadius: '4px'
				};
			}
			if (val < 70 && val >= 40) {
				return {
					backgroundColor: "#FFEC9A",
					border: "1px solid #FFEC9A",
					borderRadius: '4px'
				};
			}
			if (val < 40 ) {
				return {
					backgroundColor: "#FF9998",
					border: "1px solid #FF9998",
					borderRadius: '4px'
				};
			}
		}
	};
	const getFormatedValue = (value, col)=>{
		if(['MAI', 'Norm coverage'].includes(col)){
			if(value === 'N/A' || value === ''){
				return value;
			}else{
				let val = parseFloat(value?.replace('%', ''));
				return val?.toFixed(0)+'%';
			}			
		}else{
			return value;
		}
	}

	const handleSort = (columnKey) => {
		let direction = 'asc';
		if (sortConfig.key === columnKey && sortConfig.direction === 'asc') {
		  direction = 'desc';
		}
		setSortConfig({ key: columnKey, direction });

		const sorted = [...tableData].sort((a, b) => {
			const valA = a[columnKey];
			const valB = b[columnKey];
	
			if (valA == null) return 1;
			if (valB == null) return -1;
	
			if (!isNaN(valA) && !isNaN(valB)) {
				return direction === 'asc' ? valA - valB : valB - valA;
			}
	
			return direction === 'asc'
				? String(valA).localeCompare(String(valB))
				: String(valB).localeCompare(String(valA));
		});
	
		setTableData(sorted);
	  };
	// Handlers
	const handleMultiSelectChange = (label, values) => {
		let filterObjc = [...filterObject];
		const tempFilterObj = filterObjc?.map(itm=>
			itm.label === label ? { ...itm, selectedData: values } : itm
		)
		setFilterObject(tempFilterObj);
		const filterTableData = data?.filter(row=>{
			return tempFilterObj.every(itm => {
				const selectedData = itm.selectedData;
				if (selectedData.length === 0) return true; // Skip if no selection
				const key = 'CBU code-description' === itm.label ? 'CBU description' : itm.label; // Dynamically get the key based on the filter label
				if (!row?.hasOwnProperty(key)) return true; // Skip if the key doesn't exist in the item
				if(row[key]?.length === 0) return false;
				if(labelView === 'RMPM view' && key === 'Format'){
					const items = row[key]?.split(',');
					return selectedData.some(item => items.includes(item))
				}else{
					return selectedData?.includes(row[key]); // Check if the selectedData contains the item[key]
				}
			});
		});
		setTableData(filterTableData);
	};


	// assig option list in filter object Data
	useEffect(()=>{		
		// const filterObj = [...filterObject];
		if(filterObj?.length > 0 && data?.length > 0){
			filterObj?.forEach(itm=>{
				let dataKey =  itm?.label;	
				let uniqueValues = [...new Set(data.map(itm => itm[dataKey]))];
				if(['Format', 'CBU description'].includes(dataKey) && label === 'RMPM view'){
					let allComaData = data.map(itm => itm[dataKey]);
					uniqueValues = [...new Set(allComaData?.map(item => item?.split(','))?.flat()?.map(str => str?.trim()))];
				}
				if(['CBU code-description'].includes(dataKey) && label === 'CBU view')	{
					uniqueValues = [...new Set(data.map(itm => itm['CBU description']))];
				}
				itm.data = uniqueValues;
			})
			setFilterObject(filterObj);
		}
		
	}, [filterObj, data, label]);

	const resetFilter = useCallback(() => {
		setFilterObject(prevFilterObj => prevFilterObj.map(itm => ({ ...itm, selectedData: [] })));
		setTableData(data);
	}, []);
	const selectedColumns = columnList.filter((a) => a.visibility === true);
	return (
		<div className={styles.card}>
			{/* card header */}
			{/* <div className={styles.cardHeader}> */}
				<div className={styles.cardHeaderContent}>
					<div className={styles.cardHeaderText}>{label}</div>
					<div className={styles.cardHeaderDropDown}>
					{filterObject
					.filter(filter => filter.isFavourite)
					.map(filter => (
						<ListItem key={filter.label} className={styles.listitms}>
						<MultiSelectWithSearchInput
							key={filter.label}
							label={filter.label}
							options={filter.data}
							filterValues={filter.selectedData}
							handleFilter={handleMultiSelectChange}
							disabled={false}
							isLabelShow={false}
						/>
						</ListItem>
					))}

						<img src={resetBtn} onClick={resetFilter} alt="Reset Filters" className={styles.resetBtn} />
					</div>
					
				</div>
			{/* </div> */}
			<hr className={styles.divideLine} />
			<div>
				<TableContainer className={styles.table} sx={{ height: "25vh", margin: '10px 0' }} ref={containerRef}>
					<Table size="small" stickyHeader>
						<TableHead>
							{selectedColumns?.length > 0 ? (
								<TableRow>
									{selectedColumns?.map((col) => (
										<StyledTableCell
											key={col?.label}
											onClick={() => col.sortable && handleSort(col.label)}
											sx={{cursor: col.sortable ? "pointer" : "default", backgroundColor: "var(--primany-table-header-color)" }}
										>
											<div className={styles.sortIcon}>
												{col?.label}
												{col.sortable && sortConfig.key === col.label && ( 
													<img
														src={vector}
														alt="sort icon"
														width="14px"
														height="14px"
														style={{
															marginLeft: "4px",
														}} 
													/>
												)}
											</div>
										</StyledTableCell>
									))}
								</TableRow>
							) : (
								<TableRow>
									<StyledTableCell
										sx={{ backgroundColor: "var(--primany-table-header-color)" }}
									>
										No columns available...
									</StyledTableCell>
								</TableRow>
							)}
						</TableHead>
						<TableBody>
							{chankData?.length && chankData?.length > 0 ? (
								chankData?.map((row, idx) => (
									<StyledTableRow key={`row${idx}}`}>
										{selectedColumns.map((col, index) => (
											<StyledTableCell key={`col${idx + index}`}>
												{['CBU description', 'Material description'].includes(col?.label) ?
													<CustomTooltip title={row[col?.label]} placement="top">{row[col?.label]}</CustomTooltip> :
													<p style={getBGColor(row[col?.label], col?.label)}>{getFormatedValue(row[col?.label], col?.label)}{['Factory MSTN','Factory SI','RMPM coverage', 'Agile OR'].includes(col?.label) && '%'}</p>
												}
											</StyledTableCell>)
										)}
									</StyledTableRow>
								))
							) : (
								<StyledTableRow>
									<StyledTableCell sx={{ whiteSpace: "nowrap", minWidth: "100px" }} colSpan={label === 'CBU view' ? 8 : 7}>
										{tableData.length > 0 && chankData?.length === 0 ? 'Loading...':'Data not available...'}
									</StyledTableCell>
								</StyledTableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		</div>
	);
};

export default HeatMap;
